import React from "react"
import "./Index.scss"

const MainContent = function(props) {
    return (
        <div id="contentTop" className="page-wrapper">
            {props.children}
        </div>
    )
}

export default MainContent



// WEBPACK FOOTER //
// ./src/app/components/common/MainContent/index.js